import { Box } from '@lifeomic/chroma-react/components/Box';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';
import { DashboardInjectedProps } from '../../util/types';

import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { ActionItems } from './ActionItems';
import {
  ExecutiveSummaryProvider,
  useExecutiveSummaryData,
} from '../ExecutiveSummary/Context';
import { ControlBar } from '../ExecutiveSummary/ControlBar';

const useStyles = makeStyles(theme => ({
  loader: {
    width: theme.pxToRem(20),
  },
  loaderDotStyle: {
    fill: theme.palette.blue.main,
  },
  actionItemsContainer: {
    overflow: 'auto',
    padding: theme.pxToRem(16),
    backgroundColor: theme.palette.background.default,
  },
}));

const _ActionPlan = (props: DashboardInjectedProps) => {
  const classes = useStyles();

  const {
    executiveSummary,
    isLoading,
    removeActivity,
    addActionItem,
    updateActionItem,
    toggleActionItemStatus,
  } = useExecutiveSummaryData();

  if (isLoading && !executiveSummary) {
    return (
      <Box fullHeight fullWidth align="center" justify="center">
        <DotLoader
          className={classes.loader}
          dotStyle={classes.loaderDotStyle}
          size={0}
        />
      </Box>
    );
  }

  return (
    <Box direction="column" gap={0} fullHeight>
      <ControlBar
        patientId={props.patient.id}
        disableControls={true}
        enabledSummaries={['action-plan']}
        fixedImpressionType="actionItems"
      />
      <Box className={classes.actionItemsContainer} fullHeight>
        <ActionItems
          forcedViewMode={'expanded'}
          removeActivity={removeActivity}
          addActionItem={addActionItem}
          updateActionItem={updateActionItem}
          toggleActionItemStatus={toggleActionItemStatus}
        />
      </Box>
    </Box>
  );
};

const ActionPlan = (props: DashboardInjectedProps) => {
  return (
    <ExecutiveSummaryProvider
      patient={props.patient}
      forceLatestCarePlan={true}
    >
      <_ActionPlan {...props} />
    </ExecutiveSummaryProvider>
  );
};

export default ActionPlan;
